export function resolveExportImageAlt(
  alt: string,
  href: string,
  editorMode: boolean,
): string {
  const trimmed = alt.trim();
  if (trimmed) {
    return trimmed;
  }
  if (editorMode || !href) {
    return '';
  }
  return 'View linked image';
}
